import RouteScanner from '@/global/services/module-directory-scanner/route-scanner'

export default (new RouteScanner())
  .withoutChildRoutes()
  .withoutEmptyFiles()
  .toFormatVueRouterUnderstands()
